export default {
    // récuperer toutes les guichets dans la base de données 
    get_all_typeoperations_headers(serverParams){
        return axios.post('/typeoperations/entetes/list?page=' + serverParams.page, serverParams, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },

   
    // récuperer toutes les guichets dans la base de données 
    post_typeoperations_headers(typeoperation){
        return axios.post('/typeoperations/entete', typeoperation, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    put_typeoperations_headers(id, typeoperation){
        return axios.put('/typeoperations/entete/' + id, typeoperation, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        })
    },
    // modifie l'entité dont le parametre est = id
    show_typeoperations_headers(id){
        return axios.get('/typeoperations/entete/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    delete_typeoperations(id){
        return axios.delete('/typeoperations/entete'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        })
    },

}